export const BOOKING_SERVICES_BASE = 'https://package-booking.otpusk.com/api/';
